import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_11_1 from '../../assets/press/Press-11-1.webp';
import P_11_2 from '../../assets/press/Press-11-2.webp';
import P_11_3 from '../../assets/press/Press-11-3.webp';
import P_11_4 from '../../assets/press/Press-11-4.webp';
import P_11_5 from '../../assets/press/Press-11-5.webp';

const pressList = [
	{
		image: P_1,
		title:
			'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
		link: ROUTE_NAMES.PRESS1,
	},
	{
		image: P_2,
		title:
			'21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
		link: ROUTE_NAMES.PRESS2,
	},
	{
		image: P_3,
		title:
			'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
		link: ROUTE_NAMES.PRESS3,
	},
];

export default function PressPage11() {
	const location = useLocation();
	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	return (
		<div className='press-single-page'>
			<Helmet>
				<title>
					The Urban Blueprint Rewritten: 21 Hollywood by Starlife Group
				</title>
				<meta
					name='description'
					content='What if your next address didn’t just offer a roof and walls but ambition, vision, and maybe a rooftop yoga session with ocean air as your soundtrack?'
				/>
				<meta
					name='keywords'
					content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>
			<div className='col-1'>
				<img src={P_11_1} alt='press-image' />
				<h1 className='press-page-title'>
					The Urban Blueprint Rewritten: 21 Hollywood by Starlife Group
				</h1>
				<span className='author-name'>By Sylvester</span>
				<span className='author-name'>June 11, 2025</span>
				<Link
					to={
						'https://muse.international/the-urban-blueprint-rewritten-21-hollywood-by-starlife-group/'
					}
				>
					<span className='author-name'>Source</span>
				</Link>

				<div className='press-page-content'>
					<h2>Inside the Fabric of 21 Hollywood</h2>
					<p>
						What if your next address didn’t just offer a roof and walls but
						ambition, vision, and maybe a rooftop yoga session with ocean air as
						your soundtrack?
					</p>
					<p>
						Welcome to <b>21 Hollywood</b>, a{' '}
						<b>2025 TITAN Property Awards winner</b> and a development that
						doesn’t tiptoe into the future as it strides in, coffee in one hand
						and conference call in the other. Rising 14 stories over the pulse
						of Hollywood, Florida, this mixed-use development by Starlife Group
						is a marvel of blueprints brought to life. It’s a daily lifestyle
						upgrade, dressed in smart tech and sharp design, with just enough
						swagger to feel like you’re part of something bigger.
					</p>
					<img src={P_11_2} alt='press-image_2' />
					<p>
						Let’s be honest. In a world crowded with condos promising “modern
						living,” the phrase begins to feel like white noise. So, what makes
						21 Hollywood worth the double take?
					</p>
					<p>
						To begin with the obvious facts: Sleek yet substantive, 21 Hollywood
						is composed of 200 finely crafted residential units suspended above
						a curated stretch of retail and commercial space, just under 10,000
						square feet. It's located in a picturesque spot that practically
						winks at the Atlantic Ocean.
					</p>
					<p>
						<b>
							But those numbers, while impressive, are only the opening act. The
							headliner? The thinking behind the project.
						</b>
					</p>
					<p>
						Visionary developer Starlife Group didn’t just want to stack floors
						and hang the drywall. They collaborated with international architect
						Kobi Karp, a name whispered with admiration in design circles to
						conceive a structure that listens to how people want to live today.
						It refuses the vertical sterility of typical towers. Instead, it
						communicates with the city, extending into its social fabric and
						folding its energy back inward. Walkable, approachable, and
						thoughtfully landscaped, 21 Hollywood avoids becoming a monolith and
						instead performs like an ecosystem.
					</p>
					<img src={P_11_3} alt='press-image_3' />
					<p>
						Think co-working suites where the coffee is strong and the Wi-Fi
						stronger. Business stations that don’t just look like office spaces
						but work like them. Postal services that remember this is still a
						physical world. And rentable business suites because not every
						hustle fits a corner of the kitchen table.
					</p>
					<p>
						There’s something poetic about taking a rooftop yoga class while
						traffic hums far below and the ocean glimmers in the distance. Then
						there’s the resort-style pool deck, proving that “residential
						luxury” doesn’t have to mean sterile design and a lonely lounge
						chair. Dedicated co-working lounges and rentable business suites
						speak to a world untethered from conventional office hours, offering
						infrastructure for entrepreneurs and creatives whose workplaces
						shift daily.
					</p>
					<img src={P_11_4} alt='press-image_4' />
					<p>
						t’s also worth mentioning that the entire development is wired for
						sustainability. Technological intelligence runs quietly yet
						decisively through the project. Smart home integrations anticipate
						the rhythms of those within, while energy-efficient systems echo a
						broader commitment to environmentally responsible design.
					</p>
					<p>
						But the cleverness is in how unintrusive this sophistication feels -
						it supports, never disrupts. Because the only thing more luxurious
						than smart home tech is knowing your building was designed with a
						conscience.
					</p>
					<p>
						<b>
							21 Hollywood answers that with conviction. Need a confident,
							undeniably bold development that is delightfully human in its
							design and choices? This is it.
						</b>
					</p>
					<img src={P_11_5} alt='press-image_5' />
					<p>
						In a market saturated with glass towers that prioritize flash over
						function, 21 Hollywood threads precision with poetry. It is an
						address, yes, but also an idea, a rebuttal to uninspired development
						and a quiet, confident reminder that building for the present is
						only meaningful when done with the foresight of tomorrow.
					</p>
					<p>
						So if you’ve been searching for a place that doesn’t just keep up
						with your life but actually supports it, guides it, and maybe even
						gives it a subtle nudge forward, 21 Hollywood may have your number.
						They probably already texted you a welcome note because here, the
						future doesn’t knock.
					</p>
				</div>
			</div>
			<div className='col-2'>
				<div className='sticky-press-list'>
					<h3>Press Articles</h3>
					{pressList.map((item, idx) => (
						<Link to={item.link} key={idx}>
							<div className='other-press-card'>
								<img src={item.image} alt={`press-${idx}`} />
								<p>{item.title}</p>
							</div>
						</Link>
					))}
					<Link to={ROUTE_NAMES.PRESS}>
						<button className='view-all-press-btn'>View All</button>
					</Link>
				</div>
			</div>
		</div>
	);
}
